import { useState, useEffect } from 'preact/hooks'
import { signInWithGoogle, signOut, onAuthStateChanged } from '../services/auth'
import type { User } from 'firebase/auth'

interface UseAuthResult {
  user: User | null
  isLoading: boolean
  signIn: () => Promise<void>
  signOut: () => Promise<void>
}

export function useAuth(): UseAuthResult {
  const [user, setUser] = useState<User | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged((u) => {
      setUser(u)
      setIsLoading(false)
    })
    return unsubscribe
  }, [])

  const handleSignIn = async () => {
    try {
      await signInWithGoogle()
    } catch (e) {
      console.error('Sign-in failed:', e)
    }
  }

  const handleSignOut = async () => {
    try {
      await signOut()
    } catch (e) {
      console.error('Sign-out failed:', e)
    }
  }

  return { user, isLoading, signIn: handleSignIn, signOut: handleSignOut }
}
